module.exports = __webpack_public_path__ + "img/bms-gestao-logo.101399d5.png";